import axios from "axios";
import Vue from "vue";

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "/api-quatro"
    : "https://pmt.hmc.co.il/wp-json/quatro/v1";

export const authHeader = () => `Bearer ${Vue.$cookies.get("hmc_token")}`;

export async function getUserDetails(license) {
  try {
    const { status, data } = await axios.get(
      `${API_URL}/profile?license=${license}`,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200 && data["status"] === "success") return data["data"];
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserDetails(license, body) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile?license=${license}`,
      body,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserAvatar(license) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile/avatar?license=${license}`,
      {},
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function sendLicensePlateForm(formData) {
  try {
    const { data } = await axios.post(`${API_URL}/car-license`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendPolicies(formData) {
  try {
    const { data } = await axios.post(`${API_URL}/policies`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendCelloSign(payload, url) {
  try {
    const { data } = await axios.post(`${API_URL}/${url}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function getDoctorSentencesByLicense(doctorLicense) {
  try {
    const { data } = await axios.get(
      `${API_URL}/doc-summary?license=${doctorLicense}`,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    return data;
  } catch (err) {
    throw err;
  }
}

export async function updateDoctorSentencesByLicense(doctorLicense, payload) {
  try {
    const { data } = await axios.post(
      `${API_URL}/doc-summary?license=${doctorLicense}`,
      payload,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendConsentCelloSign(payload) {
  try {
    const { data } = await axios.post(`${API_URL}/consent-cellosign`, payload, {
      headers: {
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}
